// Not DRY'ed up for readability

export const BASE = '/app',
    ANYTIME_FEEDBACK_PROVIDE = '/anytime-feedback/provide/:requestId/:reviewerId?',
    ANYTIME_FEEDBACK_REQUEST_CREATE = '/anytime-feedback/request',
    ANYTIME_FEEDBACK_REQUEST_EDIT = '/anytime-feedback/request/:id',
    ANYTIME_FEEDBACK_GIVE_CREATE = '/anytime-feedback/give',
    ADMIN_OVERVIEW = '/admin/settings',
    ADMIN_FEATURE_SELECTION = '/admin/settings/feature-selection',
    ADMIN_REPORT_EMAILS = '/admin/settings/email-reports',
    ADMIN_MAIL_LOG = '/admin/settings/mail-log/:companyId?',
    ADMIN_BOUNCED_EMAILS = '/admin/settings/bounced-emails',
    ADMIN_MESSAGE_STATISTICS = '/admin/settings/message-statistics/:companyId?',
    ADMIN_MERGE_USERS = '/admin/settings/merge-users/:sourceUserId?',
    ADMIN_OBJECTIVE_CATEGORIES = '/admin/settings/objective/categories',
    ADMIN_OBJECTIVE_RATINGS = '/admin/settings/objective/ratings',
    ADMIN_PAYMENT_DETAILS = '/admin/settings/payment-details',
    ADMIN_BILLING = '/admin/settings/billing',
    ADMIN_BILLING_CHECKOUT = '/admin/settings/checkout',
    ADMIN_BILLING_CHECKOUT_STEP = '/admin/settings/checkout/:defaultStep',
    ADMIN_BADGES = '/admin/settings/badges',
    ADMIN_EMAIL_MANAGE = '/admin/settings/emails',
    ADMIN_HELPFUL_RESOURCES = '/admin/settings/helpful-resources',
    ADMIN_SAMPLE_CONTENT = '/admin/settings/sample-content',
    ADMIN_SAMPLE_CONTENT_PROGRESS = '/admin/settings/sample-content-progress/:mode?',
    ADMIN_HIP_CHAT = '/admin/settings/hip-chat',
    ADMIN_DESIGN = '/admin/settings/design',
    ADMIN_COMPANY_SETTINGS = '/admin/settings/company',
    ADMIN_CUSTOM_WORDING = '/admin/settings/custom-wording',
    ADMIN_CSV = '/admin/settings/csv',
    ADMIN_CSV_HISTORY = '/admin/settings/csv/history',
    ADMIN_CSV_CONFIG = '/admin/settings/csv/config',
    ADMIN_CSV_IMPORT = '/admin/settings/csv/import',
    ADMIN_DELETE_COMPANY = '/admin/delete-company',
    INTEGRATIONS = '/admin/integrations',
    INTEGRATIONS_BAMBOO = '/admin/integrations/bamboo',
    INTEGRATIONS_BAMBOO_HISTORY = '/admin/integrations/bamboo/history',
    INTEGRATIONS_BAMBOO_PREVIEW = '/admin/integrations/bamboo/preview',
    INTEGRATIONS_BAMBOO_CONFIG = '/admin/integrations/bamboo/config',
    INTEGRATIONS_GOOGLE_WORKSPACE = '/admin/integrations/google-workspace',
    INTEGRATIONS_GOOGLE_WORKSPACE_HISTORY = '/admin/integrations/google-workspace/history',
    INTEGRATIONS_GOOGLE_WORKSPACE_PREVIEW = '/admin/integrations/google-workspace/preview',
    INTEGRATIONS_GOOGLE_WORKSPACE_CONFIG = '/admin/integrations/google-workspace/config',
    INTEGRATIONS_SLACK_CONFIGURATION = '/admin/integrations/slack',
    INTEGRATIONS_NAMELY = '/admin/integrations/namely',
    INTEGRATIONS_NAMELY_HISTORY = '/admin/integrations/namely/history',
    INTEGRATIONS_NAMELY_PREVIEW = '/admin/integrations/namely/preview',
    INTEGRATIONS_NAMELY_CONFIG = '/admin/integrations/namely/config',
    INTEGRATIONS_PERSONIO = '/admin/integrations/personio',
    INTEGRATIONS_PERSONIO_HISTORY = '/admin/integrations/personio/history',
    INTEGRATIONS_PERSONIO_PREVIEW = '/admin/integrations/personio/preview',
    INTEGRATIONS_PERSONIO_CONFIG = '/admin/integrations/personio/config',
    INTEGRATIONS_KALLIDUS = '/admin/integrations/kallidus',
    INTEGRATIONS_KALLIDUS_HISTORY = '/admin/integrations/kallidus/history',
    INTEGRATIONS_KALLIDUS_PREVIEW = '/admin/integrations/kallidus/preview',
    INTEGRATIONS_KALLIDUS_CONFIG = '/admin/integrations/kallidus/config',
    INTEGRATIONS_CALENDAR_INTEGRATION = '/admin/integrations/calendar-integration',
    INTEGRATIONS_SAML = '/admin/integrations/saml',
    INTEGRATIONS_WORKDAY = '/admin/integrations/workday',
    INTEGRATIONS_WORKDAY_HISTORY = '/admin/integrations/workday/history',
    INTEGRATIONS_WORKDAY_PREVIEW = '/admin/integrations/workday/preview',
    INTEGRATIONS_WORKDAY_CONFIG = '/admin/integrations/workday/config',
    INTEGRATIONS_SFTP = '/admin/integrations/sftp',
    INTEGRATIONS_SFTP_HISTORY = '/admin/integrations/sftp/history',
    INTEGRATIONS_SFTP_CONFIG = '/admin/integrations/sftp/config',
    INTEGRATIONS_CUSTOM_CSV = '/admin/integrations/custom-csv',
    INTEGRATIONS_CUSTOM_CSV_HISTORY = '/admin/integrations/custom-csv/history',
    INTEGRATIONS_CUSTOM_CSV_PREVIEW = '/admin/integrations/custom-csv/preview',
    INTEGRATIONS_CUSTOM_CSV_CONFIG = '/admin/integrations/custom-csv/config',
    INTEGRATIONS_WORKABLE = '/admin/integrations/workable',
    INTEGRATIONS_WORKABLE_HISTORY = '/admin/integrations/workable/history',
    INTEGRATIONS_WORKABLE_PREVIEW = '/admin/integrations/workable/preview',
    INTEGRATIONS_WORKABLE_CONFIG = '/admin/integrations/workable/config',
    AUDIT_LOG = '/observer/audit-log',
    SESSION_MANAGER = '/manage-user-sessions/:userId',
    DASHBOARD = '/home',
    DASHBOARD_ITEM = '/home/item/:itemId',
    INBOX = '/inbox',
    DOWNLOADS = '/downloads',
    ROLES = '/system-access-roles',
    MERGE_COMPANY = '/mergeCompany',
    COMPANY_ANALYTICS = '/labs/company-analytics/:companyId',
    ADMIN_INSIGHTS = '/admin/insights',
    INSIGHTS = '/insights',
    HR_AUTOMATIONS = '/admin/automations',
    EMPLOYEE_AUTOMATIONS = '/automations',
    FEEDBACK_PROVIDE = '/feedback/provide/:id',
    FEEDBACK_PREVIEW_ZEN = '/feedback-cycles/new-preview/:cycleId',
    FEEDBACK_USER = '/feedback',
    FEEDBACK_USER_VIEW = '/feedback/view/:id',
    FEEDBACK_USER_VIEW_MULTIPLE = '/feedback/view-all/:id',
    FEEDBACK_USER_BY_YOU = '/feedback/by-you',
    FEEDBACK_USER_TODO = '/feedback/todo',
    FEEDBACK_USER_TEAM = '/feedback/team',
    FEEDBACK_USER_TEAM_ANYTIME = '/feedback/team/anytime',
    FEEDBACK_USER_TEAM_CYCLES = '/feedback/team/cycle',
    FEEDBACK_USER_TEAM_SINGLE_CYCLE = '/feedback/team/cycle/:managerId/:cycleId',
    FEEDBACK_USER_COMPANY = '/feedback/company',
    FEEDBACK_USER_COMPANY_ANYTIME = '/feedback/company/anytime',
    FEEDBACK_USER_COMPANY_CYCLES = '/feedback/company/cycle',
    FEEDBACK_USER_COMPANY_SINGLE_CYCLE = '/feedback/company/cycle/:cycleId',
    FEEDBACK_USER_COMPANY_CYCLE_CREATE = '/feedback/company/cycle/create',
    FEEDBACK_USER_COMPANY_CYCLE_EDIT = '/feedback/company/cycle/edit/:cycleId',
    FEEDBACK_USER_COMPANY_CYCLE_COPY = '/feedback/company/cycle/copy/:cycleId',
    MESSAGE_SINGLE = '/messages/:id',
    PRAISE_SINGLE = '/praise/:id',
    PRAISE_STREAM = '/praise',
    MEETING_PAGE = '/meetings/:userIds',
    MEETING_OVERVIEW = '/meetings',
    MEETING_OVERVIEW_TEMPLATE = '/meetings/template',
    MEETING_OVERVIEW_TEMPLATES = '/meetings/templates',
    MEETING_OVERVIEW_TEMPLATES_EDIT_PERSONAL = '/meetings/templates/personal/:templateId',
    MEETING_OVERVIEW_TEMPLATES_EDIT_COMPANY = '/meetings/templates/company/:templateId',
    MEETING_OVERVIEW_TEMPLATES_CREATE_PERSONAL = '/meetings/templates/create-personal',
    MEETING_OVERVIEW_TEMPLATES_CREATE_COMPANY = '/meetings/templates/create-company',
    MEETING_OVERVIEW_SHARED = '/meetings/shared',
    MEETING_OVERVIEW_TEAM_INSIGHTS = '/meetings/team',
    MEETING_OVERVIEW_COMPANY_INSIGHTS = '/meetings/company',
    MEETING_DEDICATED = '/meeting/:meetingId',
    MEETING_SHARED = '/meetings/shared/:userIds',
    MEETING_SHARED_DEDICATED = '/meetings/shared/meeting/:meetingId',
    MEETING_TEMPLATES_CREATE = '/meetings/template/create',
    MEETING_TEMPLATES_EDIT = '/meetings/template/:templateId',
    NOTIFICATIONS_PAGE = '/notifications',
    OBJECTIVE_BROWSER = '/objectives',
    OBJECTIVES_TEAM = '/objectives/team',
    OBJECTIVES_TEAM_BROWSE = '/objectives/team/browse',
    OBJECTIVES_TEAM_LIST = '/objectives/team/list',
    OBJECTIVES_TEAM_CYCLES = '/objectives/team/cycles',
    OBJECTIVES_TEAM_CYCLE = '/objectives/team/cycles/:cycleId',
    OBJECTIVES_COMPANY = '/objectives/company',
    OBJECTIVES_COMPANY_LIST = '/objectives/company/list',
    OBJECTIVES_COMPANY_BROWSE = '/objectives/company/browse',
    OBJECTIVES_COMPANY_HIERARCY = '/objectives/company/hierarchy',
    OBJECTIVES_COMPANY_CASCADE = '/objectives/company/cascade',
    OBJECTIVES_COMPANY_CYCLES = '/objectives/company/cycles',
    OBJECTIVES_COMPANY_CYCLE = '/objectives/company/cycles/:cycleId',
    OBJECTIVE_SINGLE = '/objectives/:cycleId/:objectiveId',
    OBJECTIVE_SINGLE_BY_ID = '/objective/:id',
    OBJECTIVE_CLONE = '/objective/:id/clone',
    OBSERVER_COMPANY = '/observer/companies',
    OBSERVER_COMPANY_USER = '/observer/companies/:companyId/users',
    OBSERVER_USER = '/observer/users',
    OBSERVER_COMPANY_PAGE = '/observer/company/:companyId',
    OBSERVER_SOURCE_STATS = '/observer/usage-source-stats',
    OBSERVER_BILLING_COMPANY = '/observer/billing/:companyId',
    OBSERVER_EXPERIMENT = '/observer/experiments',
    OBSERVER_EXPERIMENT_CREATE = '/observer/experiments/create',
    OBSERVER_EXPERIMENT_VIEW = '/observer/experiments/:codeId',
    OBSERVER_FEATURES = '/observer/features',
    OBSERVER_FEATURES_BULK_TOGGLE = '/observer/features/:featureId',
    OBSERVER_CUSTOMER_HEALTH = '/observer/customer-health',
    OBSERVER_CUSTOMER_HEALTH_COMPANY = '/observer/customer-health/:companyId',
    OBSERVER_SURVEY = '/observer/surveys/:surveyId',
    OBSERVER_USERS_TO_EMAILS = '/observer/users-to-emails',
    PERSONAL_ACCESS_TOKENS = '/personal-access-tokens',
    YOUR_REVIEWS = '/reviews',
    REVIEWS_TEAM = '/reviews/team',
    REVIEWS_TEAM_CYCLE = '/reviews/team/:cycleId',
    REVIEWS_COMPANY = '/reviews/company',
    REVIEWS_COMPANY_CYCLE = '/reviews/company/:cycleId',
    REVIEWS_COMPANY_COMPARE_CYCLES = '/reviews/company/compare',
    REVIEWS_COMPANY_CYCLE_CREATE = '/reviews/company/create',
    REVIEWS_COMPANY_CYCLE_COPY = '/reviews/company/copy/:cycleId',
    REVIEWS_COMPANY_CYCLE_EDIT = '/reviews/company/edit/:cycleId',
    REVIEW_EDIT = '/reviews/edit/:reviewId',
    REVIEW_VIEW = '/reviews/view/:reviewId',
    REVIEW_PREVIEW_QUESTIONNAIRE = '/reviews/preview/questionnaire/:cycleId',
    REVIEW_GRAPH_TEAM_WITH_CYCLE = '/reviews/graph/team/:managerId/:cycleId',
    REVIEW_QUESTIONNAIRE_ADMIN_PAGE = '/admin/reviews/questionnaires',
    USER_EDIT = '/users/edit',
    USER_PROFILE = '/user/:id',
    USER_EXPORT_DATA = '/user/:id/export-data',
    USER_CHANGE_PASSWORD = '/user/:id/change-password',
    USER_SETTINGS = '/user-settings',
    USER_PROFILE_SHORT = '/user',
    YOUR_SURVEYS = '/surveys',
    YOUR_SURVEYS_ANSWER_SURVEY = '/surveys/answer/:surveyInstanceId',
    YOUR_SURVEYS_SHARED = '/surveys/shared',
    YOUR_SURVEYS_SHARED_WITH_SURVEY = '/surveys/shared/:surveyId',
    YOUR_SURVEYS_SHARED_WITH_SURVEY_PRINT = '/surveys/shared/:surveyId/print',
    YOUR_SURVEYS_COMPANY = '/surveys/company',
    YOUR_SURVEYS_COMPANY_WITH_SURVEY = '/surveys/company/:surveyId',
    YOUR_SURVEYS_COMPANY_CREATE = '/surveys/company/create',
    YOUR_SURVEYS_COMPANY_EDIT = '/surveys/company/edit/:surveyId',
    YOUR_SURVEYS_COMPANY_COPY = '/surveys/company/copy/:surveyId',
    YOUR_SURVEYS_COMPANY_WITH_SURVEY_PRINT = '/surveys/company/:surveyId/print',
    PEOPLE = '/people',
    PEOPLE_TEAM = '/people/team',
    PEOPLE_TEAM_USER = '/people/team/:userId',
    PEOPLE_DIRECTORY = '/people/directory',
    PEOPLE_DIRECTORY_CREATE = '/people/directory?create',
    PEOPLE_ACTIVITES = '/people/activities',
    PEOPLE_MESSAGES = '/people/messages',
    SETTINGS = '/settings',
    SETTINGS_AUTOMATIC_USER_IMPORT = '/settings/automatic-user-import',
    SETTINGS_PRAISE = '/settings/praise',
    SETTINGS_MEETINGS = '/settings/meetings',
    SETTINGS_CYCLE_FEEDBACK = '/settings/cycle-feedback',
    SETTINGS_ANYTIME_FEEDBACK = '/settings/anytime-feedback',
    SETTINGS_ANYTIME_FEEDBACK_GENERAL = '/settings/anytime-feedback/general',
    SETTINGS_ANYTIME_FEEDBACK_TEMPLATES = '/settings/anytime-feedback/templates',
    SETTINGS_ANYTIME_FEEDBACK_AUTOMATIONS = '/settings/anytime-feedback/automations',
    SETTINGS_REVIEWS = '/settings/reviews',
    COMING_SOON = '/coming-soon',
    COMING_SOON_FEATURE = '/coming-soon/:featureId',
    ADMIN_MEETINGS = '/admin/meetings',
    ADMIN_MEETINGS_INSIGHTS = '/admin/meetings/insights',
    ADMIN_MEETINGS_SETTINGS = '/admin/meetings/settings',
    ADMIN_MEETINGS_EMAILS = '/admin/meetings/emails',
    ADMIN_MEETINGS_TEMPLATES = '/admin/meetings/templates',
    ADMIN_MEETINGS_TEMPLATES_CREATE = '/admin/meetings/templates/create',
    ADMIN_MEETINGS_TEMPLATES_EDIT = '/admin/meetings/templates/:templateId',
    ADMIN_PRAISE = '/admin/praise',
    ADMIN_PRAISE_EMAILS = '/admin/praise/emails',
    ADMIN_SURVEYS = '/admin/surveys',
    ADMIN_SURVEYS_WITH_SURVEY = '/admin/surveys/:surveyId',
    ADMIN_SURVEYS_WITH_SURVEY_PRINT = '/admin/surveys/:surveyId/print',
    ADMIN_SURVEYS_CREATE = '/admin/surveys/create',
    ADMIN_SURVEYS_EDIT = '/admin/surveys/edit/:surveyId',
    ADMIN_SURVEYS_COPY = '/admin/surveys/copy/:surveyId',
    ADMIN_OBJECTIVES_SELECT_CYCLE = '/admin/objectives',
    ADMIN_OBJECTIVES_CYCLE_OVERVIEW = '/admin/objectives/:cycleId',
    ADMIN_OBJECTIVE_CYCLE_CREATE = '/admin/objectives/create',
    ADMIN_OBJECTIVE_CYCLE_EDIT = '/admin/objectives/edit/:cycleId',
    ADMIN_OBJECTIVE_CYCLE_COPY = '/admin/objectives/copy/:cycleId',
    ADMIN_OBJECTIVES_EMAILS = '/admin/objectives/emails',
    ADMIN_FEEDBACK_SELECT_CYCLE = '/admin/feedback',
    ADMIN_FEEDBACK_WITH_CYCLE = '/admin/feedback/:cycleId',
    ADMIN_FEEDBACK_CYCLE_CREATE = '/admin/feedback/create',
    ADMIN_FEEDBACK_CYCLE_EDIT = '/admin/feedback/edit/:cycleId',
    ADMIN_FEEDBACK_CYCLE_COPY = '/admin/feedback/copy/:cycleId',
    ADMIN_FEEDBACK_TEMPLATES = '/admin/feedback/templates',
    ADMIN_FEEDBACK_REQUESTED = '/admin/feedback-requests',
    ADMIN_FEEDBACK_REQUESTED_TEMPLATES = '/admin/feedback-requests/templates',
    ADMIN_FEEDBACK_REQUESTED_SETTINGS = '/admin/feedback-requests/settings',
    ADMIN_FEEDBACK_REQUESTED_EMAILS = '/admin/feedback-requests/emails',
    ADMIN_FEEDBACK_REQUESTED_AUTOMATIONS = '/admin/feedback-requests/automations',
    ADMIN_FEEDBACK_EMAILS = '/admin/feedback/emails',
    ADMIN_REVIEWS_SELECT_CYCLE = '/admin/reviews',
    ADMIN_REVIEWS_QUESTIONNAIRES = '/admin/reviews/questionnaires',
    ADMIN_REVIEWS_WITH_CYCLE = '/admin/reviews/:cycleId',
    ADMIN_REVIEWS_COMPARE_CYCLES = '/admin/reviews/compare',
    ADMIN_REVIEW_CYCLE_CREATE = '/admin/reviews/create',
    ADMIN_REVIEW_CYCLE_EDIT = '/admin/reviews/edit/:cycleId',
    ADMIN_REVIEW_CYCLE_COPY = '/admin/reviews/copy/:cycleId',
    ADMIN_REVIEW_GRAPH_WITH_CYCLE = '/admin/reviews/graph/:cycleId',
    ADMIN_REVIEWS_EMAILS = '/admin/reviews/emails',
    ADMIN_USERS_DIRECTORY = '/admin/directory',
    ADMIN_USERS_DIRECTORY_CREATE = '/admin/directory?create',
    ADMIN_MESSAGES = '/admin/messages',
    ADMIN_MESSAGES_EMAILS = '/admin/messages/emails',
    ADMIN_DASHBOARD = '/admin/home',
    ADMIN_ADVANCED = '/admin/settings/advanced',
    ADMIN_USERSETTINGS = '/admin/settings/usersettings',
    ADMIN_EARLY_ACCESS = '/admin/early-access',
    ADMIN_EARLY_ACCESS_FEATURE = '/admin/early-access/:featureId',
    COMPANY_ONBOARDING_DEMOGRAPHIC = '/onboarding-survey/',
    COMPANY_ONBOARDING_ORIGIN = '/onboarding-survey/origin/',
    COMPANY_ONBOARDING_INTEREST = '/onboarding-survey/interestsettings/',
    COMPANY_ONBOARDING_HRIS = '/onboarding-survey/hris',
    COMPANY_ONBOARDING_DONE = '/onboarding-survey/done',
    AI_COPILOT = '/copilot',
    AI_COPILOT_CHAT = '/copilot/chat',
    AI_COPILOT_CHAT_NEW = '/copilot/chat/new',
    AI_COPILOT_CHAT_HISTORY = '/copilot/chat/:chatId',
    AI_COPILOT_ASSISTANTS = '/copilot/assistants',
    AI_COPILOT_RESOURCES = '/copilot/resources',
    ADMIN_AI_COPILOT = '/admin/copilot',
    ADMIN_AI_COPILOT_CHAT = '/admin/copilot/chat',
    ADMIN_AI_COPILOT_CHAT_NEW = '/admin/copilot/chat/new',
    ADMIN_AI_COPILOT_ASSISTANTS = '/admin/copilot/assistants',
    ADMIN_AI_COPILOT_RESOURCES = '/admin/copilot/resources',
    ADMIN_AI_COPILOT_CHAT_HISTORY = '/admin/copilot/chat/:chatId';
